import React, { Component } from "react";
import IndexRubros from '../index/IndexRubros';
import { withRouter } from "react-router-dom";


class DetalleRubro extends Component {
componentDidMount() {
  const { posicion } = this.props.match.params;
  const rubro = IndexRubros.rubros[Number(posicion)];
  this.setState({ rubro });
}
 state = {
  rubro: null
};
render() {
  const { rubro } = this.state;

  if (!rubro) {
    return (
      <div className="container">
        <p>Cargando información...</p>
      </div>
    );
  }

  return (
    <div id="main" className="wrapper style1">
      <div className="container">
        <header className="major">
          <h2>
            Museo Interactivo para la Niñez y la Juventud Hidalguense El Rehilete
          </h2>
        </header>

        <div className="col-12 center">
          <span className="icon alt major ocultar iconosareas2">
            <img
              src={
                "https://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/" +
                rubro.icono
              }
              alt="Areas"
            />
          </span>

          <h2>{rubro.nombre}</h2>
          {this._renderCard()}
        </div>
      </div>
    </div>
  );
}
		_renderCard = (label) => {
      const { rubro } = this.state;
      return rubro.formatos.map((formato, j)=>{
        let url = "/Transparencia/xlsx/a69_" + formato.xlsx + "_MINJHR.xlsx";
        let url2 = "/Transparencia/htm/a69_" + formato.html + "_MINJHR.htm";
        if(formato.xlsx_liga){
          url = formato.xlsx_liga;
        };
        if(formato.htm_liga){
          url2 = formato.htm_liga;
        };
        return ( 
          <div className="linea iconorubro col-md-4">
            <h4>{ formato.nombre }</h4>
             <a className="linea"href={ url } target="blank">
             <button type="button" className="btn btn-success"> XLXS</button></a>
             <a className="linea"href={ url2 } target="blank">
             <button type="button" className="btn btn-light">Ver Tabla</button></a>
          </div>
        );
      })
    }
}

export default withRouter(DetalleRubro);
